export default {
  subscribers: "api/subscriber-groups/",
  saveSub: "api/subscribers/",
  delSub: (id) => `api/subscribers/${id}/`,
  blackSub: "api/subscribers/?is_blacklisted=true",
  subTrue: "api/subscribers/?is_subscribed=true",
  subFalse: "api/subscribers/?is_subscribed=false",
  // subID:(id) => `api/subscriber-groups/${id}/`,
  deleteMultiple: "api/subscribers/bulk-delete/",
  pagSub: "api/subscribers/list/",
  newPageSub: "api/subscribers/paginated/?limit=10&offset=0&sort_by=email",
  test: (id) => `api/subscribers/paginated/?limit=10&offset=${id}`,


  filterSubs: (data) => {
    const params = new URLSearchParams();

    if (data.email) params.append("email", data.email);
    if (data.is_subscribed === true) params.append("is_subscribed", "true");
    if (data.is_blacklisted === true) params.append("is_blacklisted", "true");
    if (data.unsubscribed === true) params.append("is_subscribed", "false");
    if (data.group_id) params.append("group_id", data.group_id);
    if (data.offset !== null && data.offset !== undefined) params.append("offset", data.offset);
    if (data.limit !== null && data.limit !== undefined) params.append("limit", data.limit);
    if (data.current_page !== null && data.current_page !== undefined) params.append("current_page", data.current_page);

    // Always sort by email
    params.append("sort_by", "email");

    return `/api/subscribers/paginated/?${params.toString()}`;
  },

  subID: (data) => {
    // Start with the required parameter
    let url = `api/subscriber-groups/${data.id}/`;
    // Only add parameters that have true values or non-null values
    if (data.email !== null && data.email !== undefined) {
      url += `?email=${data.email}`;
    } else if (data.page !== null && data.page !== undefined) {
      url += `?page=${data.page}`;
    } else {
      url;
    }

    return url;
  },
};
